export default "__VITE_ASSET__BidsmxTR__"